import React, { forwardRef } from 'react';

import { Card, CardContent, CardHeader, Divider, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';

const headerSX = {
  '& .MuiCardHeader-action': { mr: 0 },
};
const MainCard = forwardRef(
  (
    {
      border = true,
      boxShadow,
      children,
      content = true,
      contentClass = '',
      contentSX = {},
      darkTitle,
      secondary,
      shadow,
      sx = {},
      title,
      ...others
    },
    ref
  ) => {
    const theme = useTheme();

    return (
      <Card
        ref={ref}
        {...others}
        sx={{
          border: border ? '1px solid' : 'none',
          borderColor: theme.palette.primary[200] + 75,
          ':hover': {
            boxShadow: boxShadow ? shadow || '0 2px 14px 0 rgb(32 40 45 / 8%)' : 'inherit',
          },
          ...sx,
        }}
      >
        {/* card header and action */}
        {!darkTitle && title && <CardHeader sx={headerSX} title={title} action={secondary} />}
        {darkTitle && title && (
          <CardHeader sx={headerSX} title={<Typography variant="h3">{title}</Typography>} action={secondary} />
        )}

        {/* content & header divider */}
        {title && <Divider />}

        {/* card content */}
        {content && (
          <CardContent sx={contentSX} className={contentClass}>
            {children}
          </CardContent>
        )}
        {!content && children}
      </Card>
    );
  }
);

MainCard.propTypes = {
  // eslint-disable-next-line react/require-default-props
  border: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  boxShadow: PropTypes.bool,
  children: PropTypes.node.isRequired,
  content: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/require-default-props
  contentClass: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  contentSX: PropTypes.shape({}),
  // eslint-disable-next-line react/require-default-props
  darkTitle: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  secondary: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.shape({})]),
  // eslint-disable-next-line react/require-default-props
  shadow: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  sx: PropTypes.shape({}),
  // eslint-disable-next-line react/require-default-props
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.shape({})]),
};

export default MainCard;
